import React from 'react'
import { BankItem } from '../item/BankItem'
import { useSelector } from 'react-redux'
import style from './bankList.module.scss'
import { VegaCard } from '../../../vega/card/Card'
import cx from 'classnames'
import { VegaIcon } from '../../../vega/icon/Icon'
import { useTranslation } from 'react-i18next'

/** UpdateBox component with card style */
export const PureBankList = ({ className, bankList, payment }) => {
	const { t } = useTranslation()

	if (bankList.length === 0) {
		return (
			<VegaCard className={cx(style.updateBoxEmpty, className)}>
				<VegaIcon name="dot-arrow" size={40} className={style.emptyIcon} />
				<p className={cx(style.emptyTitle)}>{t('emptyTitle')}</p>
				<p className={cx(style.emptySubtitle)}>{t('emptySubtitle')}</p>
			</VegaCard>
		)
	}
	return (
		<VegaCard className={cx(style.updateBox, className)}>
			{bankList
				? [...bankList]
						.reverse()
						.map((bank, i) => (
							<BankItem
								key={i}
								item={bank}
								payment={payment}
								isFirstBank={i === 0}
								isLastBank={i === bankList.length - 1}
							/>
						))
				: Array(3)
						.fill()
						.map((bank, i) => (
							<BankItem
								key={i}
								item={bank}
								payment={payment}
								isFirstBank={i === 0}
								isLastBank={i === 2}
							/>
						))}
		</VegaCard>
	)
}

/** UpdateBox component with card style */
export const BankList = ({ className }) => {
	const bankList = useSelector((state) => state.TrackerReducer.bankList)
	const payment = useSelector((state) => state.TrackerReducer.payment)

	return <PureBankList className={className} bankList={bankList} payment={payment} />
}
